var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09998 20.4C4.09998 19.7373 4.63723 19.2 5.29998 19.2H19.7C20.3627 19.2 20.9 19.7373 20.9 20.4C20.9 21.0628 20.3627 21.6 19.7 21.6H5.29998C4.63723 21.6 4.09998 21.0628 4.09998 20.4ZM8.05145 11.1515C8.52008 10.6829 9.27987 10.6829 9.7485 11.1515L11.3 12.703L11.3 3.60002C11.3 2.93728 11.8372 2.40002 12.5 2.40002C13.1627 2.40002 13.7 2.93728 13.7 3.60002L13.7 12.703L15.2514 11.1515C15.7201 10.6829 16.4799 10.6829 16.9485 11.1515C17.4171 11.6201 17.4171 12.3799 16.9485 12.8486L13.3485 16.4486C13.1235 16.6736 12.8182 16.8 12.5 16.8C12.1817 16.8 11.8765 16.6736 11.6514 16.4486L8.05145 12.8486C7.58282 12.3799 7.58282 11.6201 8.05145 11.1515Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.67fc626140dfd45fefa832dceada9859.svg";
export { ForwardRef as ReactComponent };